export default __webpack_public_path__ + "static/unicorn-logo-8f43ebe5cb258d945935b2d51258d8c3.png";